// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__BFlP1","content":"LayoutSettings_content__3uZSk"};